import React from "react";
import { FaChevronRight } from "react-icons/fa";

export default function FallbackCourseNotAvailable({ onClose }) {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="DESIGNED BY TAKYISKY"
    >
      <div className="relative bg-sdbodywhite rounded-xl shadow-xl max-w-md w-full p-6 mx-1">

        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-2 right-2 text-white hover:text-white bg-red-600 rounded-full px-2 py-1"
        >
          ✕
        </button>

        <h2
          id="fallback-title"
          className="text-xl font-bold text-gray-900 mb-4 text-center"
        >
          Programme Under Development
        </h2>
        <p className="text-gray-700 mb-6 text-center">
          This programme is currently under development. In the meantime, please
          explore our available programme:
        </p>

        <div className="flex justify-center ">
          <a
            href="/masters/leadership"
            className="
      inline-flex items-center
      px-5 py-3
      bg-sdorange text-sddarkgray
      rounded-lg
      hover:bg-sdorange-dark
      transition
    "
          >
            <div className="flex items-center space-x-7">
              <span>
                Explore MA in Global Business &amp; Strategic Leadership
              </span>
              <div className="flex items-center">
                <div className="w-0.5 h-5 bg-black"></div>
                <FaChevronRight className="ml-2 text-lg" aria-hidden="true" />
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
